import axios from "axios";

export const httpFinancial1GXApim = axios.create({
    baseURL: process.env.REACT_APP_FINANCE_BASE_URL,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF": "1",
    },
});
